import $http from '@/0/Libs/HttpHelper.js'
import $msg from '@/0/Libs/MessageHelper.js'

export default {

    async getByOpenId(openId) {
        
        if(!openId){
          this.$msg.error("找不到单据标识[OpenId]");
          return;
        }
        //$msg.showLoading();
        try {
          var url = "/mMesApi/ProductDataInAddOrder/Get";
          var postData = {
            OpenId : openId,
          }
          let { data: result } = await $http({
            url: url,
            method: "post",
            data : postData,
          });
  
          if (result.state != 1) {
            this.$msg.error("获取产品信息失败:" + result.msg);
            return;
          }
  
          if(!result.data){
            this.$msg.error("当前没有产品数据.");
            return;
          }

          return result;

        } catch (e) {
          console.log("e", e);
          return null;
        }  
        
      },



      async getProductData() {
        try {
          var url = "/mMesApi/ProductDataInAddOrder/GetProduct";
          let { data: result } = await $http({
            url: url,
            method: "post"
          });
  
          if (result.state != 1) {
            this.$msg.error("获取产品信息失败:" + result.msg);
            return;
          }
  
          if(!result.data){
            this.$msg.error("当前没有产品数据.");
            return;
          }
  
          return result;

        } catch (e) {
          console.log("e", e);
          return null;
        }
      },


      async submitData(postData) {

        if(!postData.PackDate){
          this.$msg.error( "生产日期不能为空.");
            return;
        }

        if(!postData.ProductOpenId){
          this.$msg.error( "产品名称不能为空.");
            return;
        }

        if (!postData.ProductBsnList || postData.ProductBsnList.length == 0) {
          this.$msg.error( "当前没有关联的箱码数据，请先添加要箱码列表中，再进行下一步.");
          return;
        }

        try {
            var url = "/mMesApi/ProductDataInAddOrder/Confirm";
            
            console.log("postData", postData);
            let { data: result } = await $http({
              url: url,
              method: "post",
              data: postData
            });

            if (result.state != 1) {
              $msg.error(result.msg);
                    
            }
            return result;            
          } catch (e) {            
            return;
          }
        }, 
        

    
}


